module.exports = __webpack_public_path__ + "static/group-image2-76944afea34e01792c3807088f4925e9.jpg";